import { useCallback, useMemo } from "react";
import useEntityTitles from "hooks/useEntityTitles";
import { MISSING_BUCKET_NAME } from "views/Constants";
const useAssetKeyMapper = (keys) => {
  const entities = useMemo(
    () => keys.filter((key) => key && key !== MISSING_BUCKET_NAME).map((id) => ({ id, type: "assets" })),
    [keys]
  );
  const { titlesById } = useEntityTitles(entities);
  return useCallback((key) => {
    var _a;
    return (_a = titlesById[key]) != null ? _a : key;
  }, [titlesById]);
};
export default useAssetKeyMapper;
